import { ReactElement } from "react";

export const ListToSentence = ({
  items,
}: {
  items: ReactElement[];
}): ReactElement | null => {
  if (items.length === 0) return null;

  if (items.length === 1) {
    return items[0];
  }

  if (items.length === 2) {
    return (
      <>
        {items[0]} and {items[1]}
      </>
    );
  }

  return (
    <>
      {items.slice(0, -1).map((item, index) => (
        <span key={index}>
          {item}
          {index < items.length - 2 ? ", " : ""}
        </span>
      ))}
      {" and "}
      {items[items.length - 1]}
    </>
  );
};
